
import { createContext, useContext, useState, ReactNode } from "react";

export interface User {
  family_name: string;
  given_name: string;
  emails: string[];
  email: string;
  scp: string;
  oid: string;
  aud?: string;
  azp?: string;
  country?: string;
  exp: number;
  iat: number;
  idp?: string;
  iss?: string;
  name: string;
  nbf?: number;
  nonce?: string;
  sub?: string;
  tfp?: string;
  ver?: string;
}

export type Auth = {
  token: string | undefined;
  user: User | undefined;
  roles?: string[];
  attributes?: { [key: string]: unknown };
};

type AuthContextType = {
  auth: Auth | undefined;
  setAuth: (auth: Auth) => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [auth, setAuth] = useState<Auth>();

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
